var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dark-theme",attrs:{"id":"app"}},[_c('HeaderBar'),_c('HeroSection',{attrs:{"id":"hero"}}),_c('SkillsSection',{attrs:{"id":"skills"}}),_c('ProjectsSection',{attrs:{"id":"projects"}}),_c('Services',{attrs:{"id":"service"}}),_c('ContactSection',{attrs:{"id":"contact"}}),_c('FooterBar')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }